module.exports = __webpack_public_path__ + "img/title3.11574a0c.png";